import React from "react";

export default function TrackPickerModal({
  hasLoadedSong,
  isLoading,
  isOpen,
  loadPercent,
  loadingSongTitle,
  onClose,
  onSelect,
  selectedSongId,
  songs,
}) {
  if (!isOpen) return null;

  const canClose = hasLoadedSong && !isLoading;

  return (
    <div
      className="stem-track-picker-backdrop"
      onClick={() => {
        if (canClose) onClose();
      }}
      role="presentation"
    >
      <div
        className="stem-track-picker-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="stem-track-picker-title"
        onClick={event => event.stopPropagation()}
      >
        <div className="stem-track-picker-header">
          <h2 id="stem-track-picker-title" className="stem-track-picker-title">
            <img
              src="/moonriivrtitle.png"
              alt="MOONRIIVR"
              className="stem-track-picker-title-image"
            />
          </h2>
          <p className="stem-track-picker-subtitle">Remix a track</p>

          {canClose ? (
            <button
              type="button"
              className="stem-track-picker-close"
              onClick={onClose}
            >
              Close
            </button>
          ) : null}
        </div>

        {isLoading ? (
          <div className="stem-track-picker-loading">
            <div className="stem-player-loading-spinner" />
            <p className="stem-player-loading-text">
              Loading {loadingSongTitle}... {loadPercent}%
            </p>
            <p className="stem-player-loading-text-italic">
              If you're on mobile turn off silent mode now.
            </p>
          </div>
        ) : (
          <div className="stem-track-picker-grid">
            {songs.map(song => {
              const isSelected = song.id === selectedSongId;
              const artUrl = isSelected
                ? song.albumArtSelectedUrl
                : song.albumArtUnselectedUrl;

              return (
                <button
                  key={song.id}
                  type="button"
                  className={
                    "stem-track-picker-option" +
                    (isSelected ? " is-selected" : "")
                  }
                  onClick={() => onSelect(song.id)}
                  disabled={isSelected}
                >
                  <img
                    src={artUrl}
                    alt={`${song.title} album art`}
                    className="stem-track-picker-art"
                  />
                  <span className="stem-track-picker-option-title">
                    {song.title}
                  </span>
                  <span className="stem-track-picker-option-subtitle">
                    {song.subtitle}
                  </span>
                </button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
